import Link from 'next/link';
import { useTranslations } from 'next-intl';

interface CookieContentProps {
  isCookieConsentAllowed: boolean | undefined;
}

interface CookieTextWrapperProps {
  children: React.ReactNode;
}

const cookiesPolicyLink = (chunks: React.ReactNode) => (
  <Link href="/privacy-policy" className="underline underline-offset-4">
    {chunks}
  </Link>
);

const boldText = (chunks: React.ReactNode) => <span className="font-bold">{chunks}</span>;

const CookieTextWrapper: React.FC<CookieTextWrapperProps> = ({ children }: CookieTextWrapperProps) => {
  return <p className="text-lg lg:text-xl text-text-primary leading-tight">{children}</p>;
};

const CookieContent: React.FC<CookieContentProps> = ({ isCookieConsentAllowed }: CookieContentProps) => {
  const t = useTranslations('layout.cookies');

  if (isCookieConsentAllowed === undefined) {
    return <CookieTextWrapper>{t.rich('consentIntro', { bold: boldText, link: cookiesPolicyLink })}</CookieTextWrapper>;
  }

  return <CookieTextWrapper>{t.rich('requiredIntro', { bold: boldText, link: cookiesPolicyLink })}</CookieTextWrapper>;
};

export default CookieContent;
